import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  history: null,
  historyPagination: null,

  availableAccounts: [],

  transferStatus: '',
};

export const transferSlice = createSlice({
  name: 'transfer',
  initialState,
  reducers: {
    setTransferHistory: (state, action) => {
      state.history = action.payload;
    },
    setTransferHistoryPagination: (state, action) => {
      state.historyPagination = action.payload;
    },

    setTransferAvailableAccounts: (state, action) => {
      state.availableAccounts = action.payload;
    },

    setTransferStatus: (state, action) => {
      state.transferStatus = action.payload;
    },

    resetTransfer: () => initialState,
  },
});

export const {
  setTransferHistory,
  setTransferHistoryPagination,

  setTransferAvailableAccounts,

  setTransferStatus,

  resetTransfer,
} = transferSlice.actions;

export default transferSlice.reducer;
